import { User } from "myfitworld-model";

export const getUserInitials = (firstName: string | undefined | null, lastName?: string | undefined | null) => {
  return `${firstName ? firstName[0] : ''}${lastName ? lastName[0] : ''}`;
};

export const getUserInitialsFromFullName = (name: string) => {
  const [firstName = "", lastName = ""] = name?.split(" ") || [];
  return getUserInitials(firstName, lastName);
};

export const getUserFullNameWithEmail = ({user}:{user?:User})=>{
  const firstName = user?.firstName ?? '';
  const lastName = user?.lastName ?? '';
  const email = user?.email ?? '';
  return `${lastName} ${firstName} = ${email}`;
}
